export default __webpack_public_path__ + "static/media/speaker45.32076da2.png";